export enum Language {
  ENGLISH = 'en-US',
  FRENCH = 'fr',
  GERMAN = 'de',
}
